<div class="activity-summary__container">
  @if (SummaryData) {
    <div class="column ">
      <div class="row summary-edit">
        <div class="col-lg-8 activity-summ-title">{{'ActivitySummary' | translate}}</div>
        <div class="col-lg-2">
          <app-button [buttontype]="editButton" (valueChange)="gotoPreviousPage($event)"></app-button>
        </div>
      </div>
      <div class="summery-edit-container">
        @if (activityName) {
          <div class="summary-location summary-header" title="{{activityName}}">
            {{activityName}}
          </div>
        }
        @if (Locations) {
          <div class="summary-header">
            <div class="summary-sub-header">{{'Location' | translate}}</div>
            <div class="summary-sub-text" title={{Locations}}>{{Locations}}</div>
          </div>
        }
        @if (Instructors) {
          <div class="summary-header">
            <div class="summary-sub-header">{{'Instructor' | translate}}</div>
            <div class="summary-sub-text" title={{Instructors}}>{{ Instructors}}</div>
          </div>
        }
        <div class="summary-header">
          <div class="summary-sub-header">{{'CoverSize' | translate}}</div>
          <div class="summary-sub-text" title="{{SummaryData.BookingSize}}">{{SummaryData.BookingSize}}</div>
        </div>
        <div class="summary-header">
          <div class="summary-sub-header">{{'FromDate' | translate}}</div>
          @if (selectedClassSchedule.length > 0) {
            <div>
              {{SummaryData.FromDate | localizeDate: 'DD MMMM YYYY'}}
            </div>
          }
          @if (selectedClassSchedule.length == 0) {
            <div>{{(SummaryData.Slots[0].EndTime) ?
              (SummaryData.Slots[0].EndTime | localizeDate: 'DD MMMM YYYY'):(SummaryData.Slots[0].Date | localizeDate: 'DD MMMM
            YYYY')}}</div>
          }
        </div>
        <div class="summary-header">
          <div class="summary-sub-header">{{'ToDate' | translate}}</div>
          @if (selectedClassSchedule.length > 0) {
            <div>
              {{SummaryData.ToDate | localizeDate: 'DD MMMM YYYY'}}
            </div>
          }
          @if (selectedClassSchedule.length == 0) {
            <div>{{(SummaryData.Slots[SummaryData.Slots.length -
              1].EndTime) ? (SummaryData.Slots[SummaryData.Slots.length - 1].EndTime | localizeDate: 'DD MMMM YYYY'):
            (SummaryData.Slots[SummaryData.Slots.length - 1].Date | localizeDate: 'DD MMMM YYYY')}}</div>
          }
        </div>
        <div class="summary-header">
          <div class="summary-sub-header">{{'timeSlots' | translate}}</div>
          <div class="open-booking-summary__item  open-booking-summary__item--slots">
            @if (isSessionClass && SelectedTimeSlots) {
              <div class="open-booking-summary__item__value">
                @for (slot of SelectedTimeSlots | slice:0:(showAllSlots ? SelectedTimeSlots.length : 4 ); track slot; let index = $index) {
                  <span
                    >
                    @if (isSessionClass) {
                      <span>
                        {{slot.Start | localizeDate: 'DD MMMM, LT'}}
                        -
                      {{slot.End | localizeDate: 'LT'}} &nbsp;</span>
                    }
                    @if (!isSessionClass) {
                      <span>{{slot.Start | localizeDate: 'dDDd MMMM'}}
                      - {{slot.End | localizeDate: 'DD MMMM'}} &nbsp; </span>
                    }
                  </span>
                }
                @if (SelectedTimeSlots.length > 4) {
                  <div class="open-booking-summary__slots-show-action"
                    (click)="showAllSlots = !showAllSlots">
                  {{showAllSlots ? 'Show Less' : '+'+(SelectedTimeSlots.length-4)+' '+'more'}}</div>
                }
              </div>
            }
            @if (!isSessionClass && selectedClassSchedule) {
              <div class="open-booking-summary__item__value">
                @for (selectedDay of selectedClassSchedule; track selectedDay; let index = $index) {
                  @if (selectedDay) {
                    <div class="selected-class-schedule__row">
                      <div class="selected-class-schedule__day">
                        {{dayOfWeek[index]}}
                      </div>
                      <div class="selected-class-schedule__session-period-list">
                        @for (slot of selectedDay; track slot) {
                          <div class="selected-class-schedule__session-period-item"
                            >
                            <span>{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            }
            @if (OpenbookingSlots) {
              <div class="open-booking-summary__item__value">
                <div class="open-booking-summary__item__value">
                  @for (slot of OpenbookingSlots | slice:0:(showAllSlots ? OpenbookingSlots.length : 4 ); track slot; let index = $index) {
                    <span
                      >
                      {{slot.LocalTime | localizeDate: 'LT'}}
                      - {{slot.EndTime | localizeDate: 'LT'}}{{OpenbookingSlots[index+1] && ','}}
                      &nbsp;
                    </span>
                  }
                </div>
                @if (OpenbookingSlots.length > 4) {
                  <div class="open-booking-summary__slots-show-action"
                    (click)="showAllSlots = !showAllSlots">
                    {{showAllSlots ? 'Show Less' : '+'+(OpenbookingSlots.length-4)+' '+'more'}}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="rate-plan-summary">
        @if (ratePlan && ratePlan.RatePlanCalculations  && ratePlan.TotalRatePlan) {
          <div class="open-booking-summary__rate-plan"
            >
            <div class="open-booking-summary__section-title">
              {{'rates' | translate}}
            </div>
            @for (slot of ($any(ratePlan.SlotList) | slice:0:(showRatePalns ? ratePlan.SlotList?.length : 4 )); track $index; let index = $index) {
              <mat-accordion
                >
                <mat-expansion-panel [expanded]="index == 0"
                  class="open-booking-summary__summary-accordian--panel open-booking-summary__summary-accordian--rate-plan">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="open-booking-summary__section-title--accordian">
                      @if (isSessionClass && activityService.bookingSection$.value) {
                        <span>
                          {{$any(slot).TimeRange.Start | date:'dd MMMM, hh:mm a' }} - {{$any(slot).TimeRange.End |
                          date:'hh:mm
                          a'}}
                        </span>
                      }
                      @if (!isSessionClass && activityService.bookingSection$.value) {
                        <span>
                          {{$any(slot).TimeRange.Start | localizeDate: 'DD MMMM' }} - {{$any(slot).TimeRange.End | localizeDate: 'DD MMMM'}}
                        </span>
                      }
                      @if (!activityService.bookingSection$.value) {
                        <span>
                          {{$any(slot).TimeRange.Start | localizeDate: 'LT' }} - {{$any(slot).TimeRange.End | localizeDate: 'LT'}}
                        </span>
                      }
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @if ($any(slot).RatePlanVariants?.TotalBaseRate) {
                    <div class="open-booking-summary__rate-row">
                      <div class="open-booking-summary__rate-label">
                        <span class="open-booking-summary__rate-label--main">{{'TotalBaseRate' |
                        translate}}</span>
                      </div>
                      <div class="open-booking-summary__rate">{{OperationCurrency}}
                        {{$any(slot).RatePlanVariants.TotalBaseRate | currencyDecimalFormatter
                      }}</div>
                    </div>
                  }
                  @if ($any(slot).RatePlanVariants?.LocationVariant) {
                    <div class="open-booking-summary__rate-row">
                      <div class="open-booking-summary__rate-label">
                        <span class="open-booking-summary__rate-label">{{'LocationVariant' | translate}} <span
                          class="sub-text">({{'forTotalOf' | translate}}
                          {{activityService.SessionBookingObj?.BookingSize}}
                        )</span>
                      </span>
                    </div>
                    <div class="open-booking-summary__rate">{{OperationCurrency}}
                    {{$any(slot).RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
                  </div>
                }
                @if ($any(slot).RatePlanVariants?.InstructorVariant) {
                  <div class="open-booking-summary__rate-row">
                    <div class="open-booking-summary__rate-label">
                      <span class="open-booking-summary__rate-label">{{'InstructorVariant' | translate}}<span
                        class="sub-text">({{'forTotalOf' | translate}}
                        {{activityService.SessionBookingObj?.BookingSize}}
                      )</span></span>
                    </div>
                    <div class="open-booking-summary__rate">{{OperationCurrency}}
                    {{$any(slot).RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
                  </div>
                }
                @if ($any(slot).bookingTypeVariants && $any(slot).bookingTypeVariants.length) {
                  <div class="open-booking-summary__rate-row"
                    >
                    <div class="open-booking-summary__rate-label">
                      <span class="open-booking-summary__rate-label sub-label">{{'BookingType' | translate}}
                      </span>
                    </div>
                  </div>
                }
                @for (variant of $any(slot).bookingTypeVariants; track $index) {
                  <div class="open-booking-summary__rate-row">
                    @if (variant.Variant) {
                      <div class="open-booking-summary__rate-label">
                        <span class="open-booking-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                        <span class="open-booking-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                      </div>
                    }
                    <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
                  </div>
                }
                @if ($any(slot).coverTypeVariants && $any(slot).coverTypeVariants.length) {
                  <div class="open-booking-summary__rate-row"
                    >
                    <div class="open-booking-summary__rate-label">
                      <span class="open-booking-summary__rate-label sub-label">{{'coverType' | translate}}
                      </span>
                    </div>
                  </div>
                }
                @for (variant of $any(slot).coverTypeVariants; track $index) {
                  <div class="open-booking-summary__rate-row">
                    @if (variant.Variant) {
                      <div class="open-booking-summary__rate-label">
                        <span class="open-booking-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                        <span class="open-booking-summary__rate-label--sub">{{variant.covers}}</span>
                      </div>
                    }
                    <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
                  </div>
                }
                @if ($any(slot).MemberShipVariant) {
                  <div class="open-booking-summary__rate-row">
                    <div class="open-booking-summary__rate-label">
                      <span class="open-booking-summary__rate-label--main">{{'MemberShipVariant' |
                      translate}}</span>
                    </div>
                    <div class="open-booking-summary__rate">{{OperationCurrency}} {{$any(slot).MemberShipVariant |
                      currencyDecimalFormatter}}
                    </div>
                  </div>
                }
                <div class="open-booking-summary__rate-row open-booking-summary__rate-total">
                  <div class="open-booking-summary__rate-label">
                    <span class="open-booking-summary__rate-label--main">{{'TotalSessionCharge' |
                    translate}}</span>
                  </div>
                  <div class="open-booking-summary__rate">{{OperationCurrency}}
                  {{$any(slot).TotalAmount | currencyDecimalFormatter}}</div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (ratePlan.SlotList.length > 4) {
            <div class="open-booking-summary__slots-show-action"
              (click)="showRatePalns = !showRatePalns">
            {{showRatePalns ? 'Show Less' : '+'+(ratePlan.SlotList.length-4)+' '+'more'}}</div>
          }
          <div class="open-booking-summary__rate-row open-booking-summary__total">
            <div class="open-booking-summary__rate-label">
              <span class="open-booking-summary__rate-label">{{'total' | translate}}</span>
            </div>
            <div class="open-booking-summary__rate">{{OperationCurrency}} {{ratePlan.TotalRatePlan !== null ?
              (ratePlan.TotalRatePlan | currencyDecimalFormatter) : '0.00'}}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
</div>